import { Route, Switch } from 'react-router'
import TopNavBar from './components/TopNavBar'
import './App.css'
import Home from './screens/Home'
import SideDrawer from './components/SideDrawer'
import DemoGallery from './screens/DemoGallery'
import BarChart from './screens/BarCharts/BarChart'
import StackedBar from './screens/BarCharts/StackedBar'
import HorizBar from './screens/BarCharts/HorizBar'
import BottomTab from './components/BottomTab'
import React, { useState, useEffect, createContext } from 'react'
import {
  FaGithub,
  FaExpandArrowsAlt,
  FaCompress,
  FaCompressArrowsAlt
} from 'react-icons/fa'
import LineChart from './screens/LineCharts/LineChart'
import AreaChart from './screens/LineCharts/AreaChart'
import PieChart from './screens/PieChart'
import BarChartGallery from './screens/Gallery/BarChart'
import LineChartGallery from './screens/Gallery/LineChart'
import PieChartGallery from './screens/Gallery/PieChart'
import BarCharts from './screens/BarCharts'
import LineCharts from './screens/LineCharts'
import PopulationPyramid from './screens/PyramidCharts/PopulationPyramid'
import { AppContext } from './AppContext'
import { appConstants } from './constants'
import { useLocation } from 'react-router-dom/cjs/react-router-dom'
import RadarChart from './screens/RadarCharts'

function App() {
  const { mobileMaxWidth } = appConstants
  const [width, setWidth] = useState(window.innerWidth)
  const [height, setHeight] = useState(window.innerHeight)
  const isMobile = width < mobileMaxWidth
  const [hideRightNav, setHideRightNav] = useState(false)
  const [isFullScreen, setIsFullScreen] = useState(false)

  useEffect(() => {
    window.addEventListener('resize', updateWindowWidth)
    window.addEventListener('resize', updateWindowHeight)
    return () => {
      window.removeEventListener('resize', updateWindowWidth)
      window.removeEventListener('resize', updateWindowHeight)
    }
  }, [])

  const [selected, setSelected] = useState('')
  let location = useLocation()

  useEffect(() => {
    let urlsArray = location.pathname.split('/')
    if (urlsArray.length > 1) {
      if (urlsArray.some((urls) => urls.startsWith('gallery'))) {
        setSelected('/gallery')
      } else if (urlsArray.some((urls) => urls === 'barchart')) {
        setSelected('/barchart')
      } else if (urlsArray.some((urls) => urls === 'horizbar')) {
        setSelected('/horizbar')
      } else if (urlsArray.some((urls) => urls === 'stackbar')) {
        setSelected('/stackbar')
      } else if (urlsArray.some((urls) => urls === 'linechart')) {
        setSelected('/linechart')
      } else if (urlsArray.some((urls) => urls === 'areachart')) {
        setSelected('/areachart')
      } else if (urlsArray.some((urls) => urls === 'piechart')) {
        setSelected('/piechart')
      } else if (urlsArray.some((urls) => urls === 'radarchart')) {
        setSelected('/radarchart')
      } else if (urlsArray.some((urls) => urls === 'popnpyramid')) {
        setSelected('/popnpyramid')
      } else {
        setSelected('/')
      }
    } else {
      setSelected('/')
    }
  }, [location.pathname])

  const updateWindowWidth = () => {
    setWidth(window.innerWidth)
  }
  const updateWindowHeight = () => {
    setHeight(window.innerHeight)
  }

  const newAppContext = {
    height,
    width,
    hideRightNav,
    setHideRightNav
  }

  const toggleExpand = () => {
    setIsFullScreen((isFull) => !isFull)
  }

  const getToggleButtonsPosition = () => {
    if (isFullScreen) return 10
    if (
      [
        '/barchart',
        '/horizbar',
        '/stackbar',
        '/linechart',
        '/areachart'
      ].includes(selected)
    )
      return 100
    return 50
  }

  const fullScreenButton = () => {
    return (
      <>
        {isMobile && selected !== '/' ? (
          <div
            className='expandButton'
            onClick={toggleExpand}
            style={{ top: getToggleButtonsPosition() }}
          >
            {isFullScreen ? <FaCompressArrowsAlt /> : <FaExpandArrowsAlt />}
          </div>
        ) : null}
      </>
    )
  }

  return (
    <AppContext.Provider value={newAppContext}>
      <div className='app'>
        {fullScreenButton()}
        {isFullScreen ? null : (
          <>
            <a
              className='git'
              style={{ top: isMobile ? 8 : 16, fontSize: isMobile ? 26 : 36 }}
              href='https://github.com/Abhinandan-Kushwaha/react-native-gifted-charts'
              target='_blank'
              rel='noreferrer'
            >
              <FaGithub />
            </a>
            <a
              className='npm'
              style={{ top: isMobile ? 12 : 20 }}
              href='https://www.npmjs.com/package/react-native-gifted-charts'
              target='_blank'
              rel='noreferrer'
            >
              <img
                src={require('./assets/npm.png')}
                className={isMobile ? 'npmLogoMobile' : 'npmLogo'}
                alt=''
              />
            </a>
            <TopNavBar isMobile={isMobile} />
          </>
        )}
        <div style={{ display: 'flex', flex: 1 }}>
          {width > 1100 && <SideDrawer height={height} />}
          <Switch>
            <Route exact path='/' render={() => <Home isMobile={isMobile} />} />
            <Route
              exact
              path='/gallery'
              render={() => <DemoGallery isMobile={isMobile} />}
            />
            <Route
              exact
              path='/barchart'
              render={
                isMobile
                  ? () => <BarCharts tab={0} isFullScreen={isFullScreen} />
                  : () => <BarChart />
              }
            />
            <Route
              exact
              path='/horizbar'
              render={
                isMobile
                  ? () => <BarCharts tab={1} isFullScreen={isFullScreen} />
                  : () => <HorizBar />
              }
            />
            <Route
              exact
              path='/stackbar'
              render={
                isMobile
                  ? () => <BarCharts tab={2} isFullScreen={isFullScreen} />
                  : () => <StackedBar />
              }
            />
            <Route
              exact
              path='/linechart'
              render={
                isMobile
                  ? () => <LineCharts tab={0} isFullScreen={isFullScreen} />
                  : () => <LineChart />
              }
            />
            <Route
              exact
              path='/areachart'
              render={
                isMobile
                  ? () => <LineCharts tab={1} isFullScreen={isFullScreen} />
                  : () => <AreaChart />
              }
            />
            <Route
              exact
              path='/piechart'
              render={() => <PieChart isMobile={isMobile} />}
            />
            <Route
              exact
              path='/radarchart'
              render={() => <RadarChart isMobile={isMobile} />}
            />
            <Route
              exact
              path='/popnpyramid'
              render={() => <PopulationPyramid isMobile={isMobile} />}
            />
            <Route exact path='/gallerybar' component={BarChartGallery} />
            <Route exact path='/galleryline' component={LineChartGallery} />
            <Route exact path='/gallerypie' component={PieChartGallery} />
          </Switch>
        </div>
        {!isFullScreen && width < 1100 && <BottomTab isMobile={isMobile} />}
      </div>
    </AppContext.Provider>
  )
}

export default App
